import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  Image
} from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import NotificationSettings from './notification-settings.component';

function NotificationSettingsModal(props) {
  const { isOpen, title, onClose, bgColorOverlay, maxW, maxH } = props;

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay backgroundColor={bgColorOverlay} />
      <ModalContent p={'24px'} bgColor={'#FAFAFA'} maxW={maxW} maxH={maxH} rounded={'12px'}>
        <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
          <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
            <p className="text-xl font-[800]">{title}</p>
            <Image
              className="w-[40px] h-[40px] cursor-pointer"
              src={CloseModalIcon}
              onClick={onClose}
              alt=""
            />
          </div>
        </ModalHeader>
        <ModalBody py={0} pl={0} pr={3} overflowY={'auto'}>
          <NotificationSettings />
        </ModalBody>
        <ModalFooter w="100%" p="0"></ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default NotificationSettingsModal;
